import { FormattedCurrency } from 'i18n';
import { FormattedMessage } from 'i18n';
import b from 'i18n/richTextFormats/b';
import React from 'react';
import styled from 'styled-components';

export default function MapMarkerHotelPrice({ packageDeparture, hotelPrice }) {
  return (
    <HotelPrice>
      <div className='text'>
        {packageDeparture ? (
          <FormattedMessage
            id='hotelcard.component.price.label'
            description='Per person, including flight'
            defaultMessage='Per person,&nbsp;&nbsp; <b>inklusive flygning</b>'
            values={{
              b,
            }}
          />
        ) : (
          <FormattedMessage
            id='hotelcard.component.priceHotelOnly.label'
            description='Per person, only hotel'
            defaultMessage='Per person, <b>only hotel</b>'
            values={{ b }}
          />
        )}
      </div>
      <div className='price'>
        <FormattedCurrency value={hotelPrice} />
      </div>
    </HotelPrice>
  );
}

const HotelPrice = styled.div`
  display: flex;
  align-items: end;
  justify-content: end;
  gap: 6px;
  flex-direction: column;
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: auto;
  background-color: white;
  padding: 6px;
  border-radius: 6px;

  .text {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    color: ${({ theme }) => (theme.colors.packageCard ? theme.colors.packageCard.text : theme.colors.text.light)};
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.2px;
    text-transform: uppercase;

    b {
      color: ${({ theme, airlineWhitelabel }) =>
        airlineWhitelabel && airlineWhitelabel.isCyprus ? theme.colors.scores.green[0] : 'inherit'};
      font-weight: 900;
    }
  }

  .price {
    font-weight: 700;
    font-size: 1.8em;
    color: ${({ theme }) => (theme.colors.packageCard ? theme.colors.packageCard.price : theme.colors.text.price)};
    line-height: unset;
    text-align: right;
    span {
      line-height: 17px;
    }
  }
`;
